/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Featureinteractivedesc2Inputs */

const zh_about_featureinteractivedesc2 = /** @type {(inputs: About_Featureinteractivedesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从测验、闪卡到汉字书写练习，多种互动组件让学生在参与中学习，告别被动接受知识的传统模式。`)
};

const en_about_featureinteractivedesc2 = /** @type {(inputs: About_Featureinteractivedesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From quizzes and flashcards to handwriting practice, diverse interactive components let students learn through participation, moving beyond passive knowledge reception.`)
};

const es_about_featureinteractivedesc2 = /** @type {(inputs: About_Featureinteractivedesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desde cuestionarios y tarjetas de memoria hasta práctica de escritura, diversos componentes interactivos permiten a los estudiantes aprender participando, superando la recepción pasiva de conocimientos.`)
};

/**
* | output |
* | --- |
* | "From quizzes and flashcards to handwriting practice, diverse interactive components let students learn through participation, moving beyond passive knowledge..." |
*
* @param {About_Featureinteractivedesc2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const about_featureinteractivedesc2 = /** @type {((inputs?: About_Featureinteractivedesc2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Featureinteractivedesc2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_about_featureinteractivedesc2(inputs)
	if (locale === "en") return en_about_featureinteractivedesc2(inputs)
	return es_about_featureinteractivedesc2(inputs)
});
export { about_featureinteractivedesc2 as "about_featureInteractiveDesc" }